import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useActions } from '../store/hooks'
import { authCheck } from '../store/actions/auth'

const PUBLIC_PATHS = ['/']

const authInitActions = { authCheck }

const AppInit = () => {
    const location = useLocation()
    const { authCheck: runAuthCheck } = useActions(authInitActions)

    useEffect(() => {
        if (PUBLIC_PATHS.includes(location.pathname)) return

        runAuthCheck()
    }, [runAuthCheck, location.pathname])

    return null
}

export default AppInit
